module.exports = __webpack_public_path__ + "img/marker_three_yellow1.c3391194.png";